module.exports = __webpack_public_path__ + "static/media/IntegrationInActive.689ac7ae.svg";